import { Component, OnDestroy, OnInit } from '@angular/core';
import { BoardingPassResponseInt } from '@app/interfaces';
import { ATBPrinterDeviceService } from '@services/devices';
import { unsubscribe ,showCarryon} from '@app/utils';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Reservation } from '@app/models/micro/reservation.model';
import { GlobalsService as GlobalServ } from '@app/services/globals.service';
import { GlobalsService } from '@app/services/micro/globals.service';
import { CarryonAddModalComponent } from '../carryon-add-modal/carryon-add-modal.component';
import { AdminService } from '@app/services/admin.service';
import { Reservation as ReservationOld } from '@app/models/reservation.model';
import { NewRelicEventsService } from '@app/services/new-relic-events.service';
import { NewRelicEventParams } from '@app/interfaces/new-relic-event.interface';
import { NEW_RELIC_EVENT } from '@app/enums';

/**
  Componente para mostrar un modal de reimpresión de tarjetas de embarque.
  Este componente permite gestionar la reimpresión de tarjetas de embarque utilizando un servicio de impresión.
  Además, maneja el estado de la impresión y cierra el modal cuando se completa la operación.
**/
@Component({
    selector: 'app-reprint-modal',
    templateUrl: './reprint-modal.component.html',
    styleUrls: ['./reprint-modal.component.scss'],
    standalone: false
})
export class ReprintModalComponent implements OnInit, OnDestroy {

  reservation: Reservation;
  reservationOld: ReservationOld;
  /**
    Datos de la tarjeta de embarque para reimpresión.
  **/
  dataBoardingPass: BoardingPassResponseInt;

  /**
    Información sobre el estado de la impresión de las tarjetas de embarque.
    - total: Número total de tarjetas de embarque a imprimir.
    - currentNum: Número de la tarjeta de embarque actual que se está imprimiendo.
  **/
  boarginPassesInfo = {
    total: 0,
    currentNum: 1
  };

  /**
    Lista de suscripciones para gestionar la desuscripción en el ciclo de vida del componente.
  **/
  subs: Subscription[] = [];

  /**
    Número de tarjetas de embarque impresas.
  **/
  numBoardingPassPrint: number = 0;

  /**
    Intervalo para gestionar el tiempo de espera entre impresiones.
  **/
  interval;

  /**
   * Flag indicating if this is a reprint action (true) or initial print (false).
   */
  isReprint: boolean = true;

  constructor(
    private ATBDevice: ATBPrinterDeviceService,
    private modalService: NgbModal,
    private _globalService: GlobalsService,
    private _admin: AdminService,
    private _globalServiceOld: GlobalServ,
    private _newRelicEvents: NewRelicEventsService,
  ) { }

  ngOnInit() {
    this.reservation = this._globalService.getReservation();
    this.ATBDevice.disable();
    this.ATBDevice.enable();
    this.reservationOld = this._globalServiceOld.getReservation();

    console.log("----- test:");
    console.log(this.dataBoardingPass);
    console.log("[isOK]:", this.ATBDevice.isOK())


    if (this.dataBoardingPass?.value?.length > 0 && this.dataBoardingPass?.pectab) {
      this.boarginPassesInfo.total = this.dataBoardingPass.value.length;
      this.printBoardinPasses();
      setTimeout(() => {
        this.ATBDevice.load(this.dataBoardingPass.pectab);
        this.ATBDevice.print(this.dataBoardingPass.value);
      }, 500);
    } else {
      console.error('-------- [ReprintModal] No valid boarding pass data to print:', this.dataBoardingPass);
      this.onClose();
    }
  }

  ngOnDestroy(): void {
    this.dataBoardingPass = null;
    this.ATBDevice.disable();
    unsubscribe(this.subs);
  }

  initPage() {
    if (this.dataBoardingPass) {
      this.boarginPassesInfo.total = this.dataBoardingPass.value.length;
      this.ATBDevice.load(this.dataBoardingPass.pectab);
      this.ATBDevice.print(this.dataBoardingPass.value);

    }
  }

  /**
    Gestiona el proceso de impresión de las tarjetas de embarque.
    - Verifica si el servicio de impresión está listo.
    - Configura un intervalo para gestionar el tiempo de espera entre impresiones.
    - Escucha los eventos del servicio de impresión para actualizar el estado de la impresión.
    - Cierra el modal cuando se completa la impresión.
    @return void - No retorna ningún valor.
  **/
  printBoardinPasses() {
    console.log("[isOK]:", this.ATBDevice.isOK())
    if (!this.ATBDevice.isOK()) {
      this.interval = setInterval(() => {
        if (this.boarginPassesInfo.currentNum < this.boarginPassesInfo.total) {
          this.boarginPassesInfo.currentNum++;
        } else {
          clearInterval(this.interval);
          this.interval = null;
          if (this.boarginPassesInfo.currentNum >= this.boarginPassesInfo.total) {
            setTimeout(() => {
              this.sendMetricToNewRelic();
              this.onClose();

              if (showCarryon(this.reservation, this._admin.admin)) {
                if (this.hasPaymentBagCarryon) {
                  this.openModalCarryOn('offer', this.reservation.flightSummary.fareFamily)//this.reservation.flightSummary.fareFamily);
                }
              }
            }, 5000);
          }
        }
      }, 5000);
    }

    const sub = this.ATBDevice.listen().subscribe({
      next: (res) => {
        console.log("[listen_ATB]:", res)
        this.numBoardingPassPrint = res.value.total;
        if (res.message === "ticketPrinted") {
          this.numBoardingPassPrint = res.value.total;
          this.boarginPassesInfo.currentNum = res.value.current;
          if (this.boarginPassesInfo.currentNum >= this.boarginPassesInfo.total) {
            setTimeout(() => {
              this.sendMetricToNewRelic();
              this.onClose();
            }, 5000);
          }
        }
      },
      error: (err) => {
        this._newRelicEvents.trackEvent(
          NEW_RELIC_EVENT.PRINT_ERROR,
          {
            isError: true,
            error_message: err,
          } as Partial<NewRelicEventParams>
        );
        this.onClose();
      },
      complete: () => {
        setTimeout(() => {
          if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }
        }, 0);
      }
    })
    this.subs.push(sub)
  }

  onClose() {
    this.modalService.dismissAll();
  }

  openModalCarryOn(type: 'offer' | 'bag' = 'bag', tarif) {
    const modalRef = this.modalService.open(CarryonAddModalComponent,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      }
    );
    modalRef.componentInstance.typeModal = type
    modalRef.componentInstance.tarif = tarif
  }

  sendMetricToNewRelic() {
    try {
      // Send event for each boarding pass printed
      for (let i = 0; i < this.boarginPassesInfo.total; i++) {
        this._newRelicEvents.trackEvent(
          this.isReprint ? NEW_RELIC_EVENT.REPRINT_BOARDING_PASS : NEW_RELIC_EVENT.PRINT_BOARDING_PASS,
        );
      }
    } catch (error) {
      this._newRelicEvents.trackEvent(NEW_RELIC_EVENT.PRINT_ERROR, {
        isError: true,
      });
    }
  }

  get hasPaymentBagCarryon(){
    if (!this.reservationOld?.passengers || !Array.isArray(this.reservationOld.passengers)) {
      return false;
    }

    const hasBags = this.reservationOld.passengers.some(p =>
      p.bagStackCarryon && Array.isArray(p.bagStackCarryon) &&
      p.bagStackCarryon.find(bag => bag.paid != true)
    );
    return hasBags;
  }
}
